/**
 * Orion script for a Shopify storefront. Load it once from theme.liquid, at the end of
 * the head section, with a deferred script tag whose src is
 * https://TRACKING_DOMAIN/shopify-orion.js. (This comment names no closing tag on
 * purpose: the file is sometimes pasted inline between script tags.)
 *
 * The lander gives a visitor's link the click id (?orion_cid=... or a cart permalink
 * with attributes[orion_click_id]=...). This script keeps it for 90 days in a
 * first-party cookie on the store's root domain and writes it, with the Meta and
 * Google click ids, into the cart attributes. Shopify then returns them on the
 * order (note_attributes), which is how Orion ties the sale back to the click and
 * sends it to the ad platform. A failed call never touches the cart.
 */
(function () {
  if (window.__orionShop) return;
  window.__orionShop = true;
  var DAYS = 90;
  var uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  var safe = /^[A-Za-z0-9_-]{1,512}$/;
  var fbcShape = /^fb\.[0-9]+\.[0-9]{13}\.[A-Za-z0-9_-]+(?:\.[A-Za-z0-9_-]+)?$/;
  var fbpShape = /^fb\.[0-9]+\.[0-9]{13}\.[0-9]+$/;

  function read(name) {
    var pair = document.cookie.split(";").find(function (part) { return part.trim().indexOf(name + "=") === 0; });
    if (!pair) return "";
    try { return decodeURIComponent(pair.trim().slice(name.length + 1)); } catch (e) { return ""; }
  }
  // The shortest parent domain the browser accepts (it refuses public suffixes such as co.uk).
  var domain = null;
  function rootDomain() {
    if (domain !== null) return domain;
    var parts = window.location.hostname.split(".");
    domain = "";
    if (parts.length > 1 && !/^[0-9.]+$/.test(window.location.hostname)) {
      for (var i = parts.length - 2; i >= 0; i--) {
        var candidate = parts.slice(i).join(".");
        document.cookie = "orion_probe=1; domain=" + candidate + "; path=/; max-age=5; SameSite=Lax";
        if (read("orion_probe") === "1") {
          document.cookie = "orion_probe=; domain=" + candidate + "; path=/; max-age=0; SameSite=Lax";
          domain = candidate;
          break;
        }
      }
    }
    return domain;
  }
  function write(name, value) {
    var root = rootDomain();
    document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; max-age=" + DAYS * 86400 +
      "; SameSite=Lax" + (root ? "; domain=" + root : "") + (window.location.protocol === "https:" ? "; Secure" : "");
  }

  var params = new URLSearchParams(window.location.search);
  function remembered(name, urlValue, valid) {
    if (urlValue && valid(urlValue)) { write(name, urlValue); return urlValue; }
    var stored = read(name);
    return stored && valid(stored) ? stored : "";
  }
  var isUuid = function (v) { return uuid.test(v); }, isSafe = function (v) { return safe.test(v); };
  var clickId = remembered("orion_cid", params.get("orion_cid") || "", isUuid).toLowerCase();
  var fbclid = params.get("fbclid") || "";
  var fbc = read("_fbc");
  if (!fbcShape.test(fbc)) fbc = remembered("orion_fbc", fbclid && isSafe(fbclid) ? "fb.1." + Date.now() + "." + fbclid : "", function (v) { return fbcShape.test(v); });
  var fbp = read("_fbp");
  if (!fbpShape.test(fbp)) fbp = "";
  var gclid = remembered("orion_gclid", params.get("gclid") || "", isSafe);
  if (!gclid) { var aw = read("_gcl_aw").split(".").pop(); if (isSafe(aw)) gclid = aw; }
  var gbraid = remembered("orion_gbraid", params.get("gbraid") || "", isSafe);
  var wbraid = remembered("orion_wbraid", params.get("wbraid") || "", isSafe);

  var attributes = {};
  if (clickId) attributes.orion_click_id = clickId;
  if (fbc) attributes.orion_fbc = fbc;
  if (fbp) attributes.orion_fbp = fbp;
  if (gclid) attributes.orion_gclid = gclid;
  if (gbraid) attributes.orion_gbraid = gbraid;
  if (wbraid) attributes.orion_wbraid = wbraid;
  if (!Object.keys(attributes).length) return;
  var body = JSON.stringify({ attributes: attributes });

  var nativeFetch = typeof window.fetch === "function" ? window.fetch.bind(window) : null;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var pending = null;
  // One write per cart: a new cart (after an order, say) has no attributes and is written again.
  function sync() {
    if (!nativeFetch) return Promise.resolve();
    var key = read("cart") + "|" + body, last = "";
    try { last = window.sessionStorage.getItem("orion_cart_attrs") || ""; } catch (e) { /* Storage denied. */ }
    if (last === key) return Promise.resolve();
    if (pending) return pending;
    pending = nativeFetch(root + "cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: body, credentials: "same-origin", keepalive: true })
      .then(function (response) {
        if (!response.ok) return;
        try { window.sessionStorage.setItem("orion_cart_attrs", read("cart") + "|" + body); } catch (e) { /* Storage denied. */ }
      })
      .catch(function () { /* The cart is left as it was. */ })
      .then(function () { pending = null; });
    return pending;
  }

  // Themes add to the cart through fetch: write the attributes first, never block the add on a failure.
  if (nativeFetch) {
    window.fetch = function (input) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      if (/\/cart\/add(?:\.js)?(?:[?#]|$)/.test(url)) {
        var args = arguments, self = this;
        var timeout = new Promise(function (resolve) { setTimeout(resolve, 1500); });
        return Promise.race([sync(), timeout]).then(function () { return nativeFetch.apply(self, args); });
      }
      return nativeFetch.apply(this, arguments);
    };
  }
  sync();
  window.addEventListener("pageshow", function (event) { if (event.persisted) sync(); });
  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (form && form.action && /\/cart\/add/.test(form.action)) sync();
  }, true);
})();
